import React, { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy‑load page components
const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const SpacePage = lazy(() => import('../pages/space/page'));
const PilatesPage = lazy(() => import('../pages/pilates/page'));
const ThermalPage = lazy(() => import('../pages/thermal/page'));
const CafePage = lazy(() => import('../pages/cafe/page'));
const MembershipsPage = lazy(() => import('../pages/memberships/page'));
const LocationPage = lazy(() => import('../pages/location/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const ProductDetailPage = lazy(() => import('../pages/shop/product/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const OrderConfirmationPage = lazy(() => import('../pages/order-confirmation/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

/**
 * Helper to wrap lazy components with a fallback.
 * This ensures that the route objects can be used in a plain `.ts` file
 * (which does not allow JSX) while still providing a user‑friendly loading UI.
 */
const withSuspense = (Component: React.LazyExoticComponent<React.ComponentType<any>>) => (
  <Suspense fallback={<div>Loading…</div>}>
    <Component />
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/the-space',
    element: <SpacePage />,
  },
  {
    path: '/reformer-pilates',
    element: <PilatesPage />,
  },
  {
    path: '/thermal-suites',
    element: <ThermalPage />,
  },
  {
    path: '/cafe',
    element: <CafePage />,
  },
  {
    path: '/pricing',
    element: <MembershipsPage />,
  },
  {
    path: '/location',
    element: <LocationPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/shop',
    element: <ShopPage />,
  },
  {
    path: '/shop/:productId',
    element: <ProductDetailPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/order-confirmation',
    element: <OrderConfirmationPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
